<!-- components/BindDialogB.vue -->
<template>
  <el-dialog
    :model-value="visible"
    title="核对免喜门店信息"
    width="600px"
    :close-on-click-modal="false"
    @update:model-value="handleClose"
  >
    <div class="dialog-content">
      <div class="verify-tips">请核对下列门店名称与门店地址是否与您在免喜侧的信息一致，确认无误后再绑定至本站点。</div>

      <el-descriptions class="verify-table" :column="1" border>
        <el-descriptions-item label="门店编号">{{ storeInfo.depotCode }}</el-descriptions-item>
        <el-descriptions-item label="门店名称">{{ storeInfo.depotName }}</el-descriptions-item>
        <el-descriptions-item label="门店地址">{{ storeInfo.fullAddress }}</el-descriptions-item>
        <!--        <el-descriptions-item label="注册手机号">{{ storeInfo.adminMobile }}</el-descriptions-item>-->
      </el-descriptions>
    </div>
    <div class="phone-display-container">
      <!-- 顶部标题 -->
      <div class="title">注册手机号</div>

      <!-- 手机号码 -->
      <div class="phone-number">{{ maskPhoneNumber(storeInfo.adminMobile) }}</div>

      <!-- 底部提示 -->
      <div class="hint-text">后台绑定无需短信验证；完整号码仅存于服务端，此处仅作核对展示。</div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose(false)">取 消</el-button>
        <el-button type="primary" :loading="bindLoading" @click="handleConfirmBind">确认绑定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import { useCurrentAppInstance } from '@zto/zpage-runtime'
const app = useCurrentAppInstance()

const props = defineProps({
  visible: { type: Boolean, default: false },
  storeInfo: { type: Object, default: () => ({}) }, // 接收父组件传来的门店信息
  siteCode: { type: [String, Number], default: '' } // 站点ID，提交接口用
})

const emit = defineEmits(['update:visible', 'bind-success'])

const bindLoading = ref(false)

const handleClose = (val: boolean) => {
  emit('update:visible', val)
}

const handleConfirmBind = async () => {
  bindLoading.value = true

  try {
    await bindStore()

    ElMessage.success('绑定成功')
    emit('update:visible', false) // 关闭弹窗
    emit('bind-success') // 通知父组件绑定成功
  } finally {
    bindLoading.value = false
  }
}
// 手机号脱敏工具
const maskPhoneNumber = (phone: any) => {
  if (!phone) return ''
  return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
}
// 模拟API
const bindStore = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await app.request({
        api: 'sys/admin/site/bindStore',
        params: { siteCode: props.siteCode, depotCode: props.storeInfo.depotCode }
      })
      if (res) {
        resolve(res.result)
      } else {
        reject({ message: res.message })
      }
    } catch (e: any) {
      reject({ message: e.message })
    }
  })
}
</script>

<style scoped lang="scss">
.verify-tips {
  background-color: #f4f4f5;
  color: #909399;
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 20px;
}
.verify-table {
  :deep(.el-descriptions__label) {
    width: 120px;
    background-color: #fafafa;
    color: #606266;
  }
}
.phone-display-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* 内容水平居中 */
  justify-content: center; /* 内容垂直居中 */
  background-color: #f2f8ff; /* 淡蓝色背景 */
  border: 1px solid #bce0fd; /* 浅蓝色边框 */
  border-radius: 6px; /* 圆角 */
  padding: 20px 24px; /* 内边距 */
  width: 480px; /* 固定宽度，可根据你的页面实际情况调整为 100% 等 */
  max-width: 100%; /* 适配小屏幕 */
  box-sizing: border-box;
  margin: 10px 48px;
}

/* 顶部标题样式 */
.title {
  color: #1677ff; /* 科技蓝字体色 */
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 12px; /* 距离下方手机号的间距 */
}

/* 中间手机号样式 */
.phone-number {
  color: #333333; /* 深灰色/近黑色 */
  font-size: 26px; /* 大字号 */
  font-weight: bold; /* 加粗 */
  letter-spacing: 2px; /* 增加字符间距，让数字看起来更舒展，符合图片效果 */
  margin-bottom: 12px; /* 距离下方提示文字的间距 */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

/* 底部提示文字样式 */
.hint-text {
  color: #999999; /* 浅灰色 */
  font-size: 12px;
}
</style>
